<template>
	<div class="know">
		<div class="flex">
			<div class="title">知识点</div>
			<div _flex="~">
				<el-button
					class="new-create"
					icon="el-icon-edit"
					@click="editVisible = !editVisible"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5112_${yy_ms}_1`]))
					"
					>{{ editVisible ? '退出' : '编辑' }}</el-button
				>
				<el-button
					class="new-create"
					icon="el-icon-plus"
					@click="dialogVisible = true"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5112_${yy_ms}_2`]))
					"
					>增加分类</el-button
				>
			</div>
		</div>
		<div v-for="(item, index) in tags" :key="item.id">
			<div _flex="~ items-center" _m="b-16px">
        <el-input
          v-if="rename[index].visible"
          @change="editKnowPointClassName(index, item.id, rename[index].value)"
          class="point-header-input"
          size="small"
          v-model="rename[index].value"
        ></el-input>
				<div class="subtitle" v-else>
          <el-tooltip :key="item.id" effect="light" :content="item.knowledge_name" placement="top">
            <div class="subtitle">{{ item.knowledge_name?.length >= 20 ? item.knowledge_name?.substring(0, 20) + '...' : item.knowledge_name }}</div>
          </el-tooltip>
        </div>
				<div _flex="~ items-center" v-if="editVisible" _m="l-15px">
					<el-button icon="el-icon-edit-outline" size="mini" @click="rename[index].visible = !rename[index].visible"
						>重命名</el-button
					>
					<el-button icon="el-icon-delete" size="mini" @click="editKnowPointClass(index, item.id)">删除</el-button>
				</div>
			</div>
			<div class="point">
				<div
					class="point-header"
          _flex="~ justify-between items-center"
				>
          <InputTopTip v-model="inputValue[item.id]" placeholder="输入新知识点，回车添加" :marginTop="10" v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5112_${yy_ms}_3`]))
					">
            <el-input
              class="point-header-input"
              v-model="inputValue[item.id]"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm(item.id, inputValue[item.id], index)"
              placeholder=""
              @input="e => inputValue[item.id] = e.replace(/\s/g, '')"
            >
            </el-input>
          </InputTopTip>
          <div _flex="1" _cursor="pointer" _h="30px" @click="isExpandId = isExpandId && isExpandId != item.id ? item.id : isExpandId && isExpandId == item.id ? null : item.id"></div>
          <i
            class="el-icon-arrow-up"
            _transition="duration-300"
            _transform="~ gpu"
            _cursor="pointer"
            @click="isExpandId = isExpandId && isExpandId != item.id ? item.id : isExpandId && isExpandId == item.id ? null : item.id"
            :class="[isExpandId == item.id ? 'w-rotate-[0deg]' : 'w-rotate-[180deg]']"
          />
				</div>
				<div class="point-context"
          _transition="duration-300"
          _transform="~ gpu"
          :style="{
            height: isExpandId == item.id ? 'auto' : '0px',
            minHeight: isExpandId == item.id ? '40px' : '0px',
            maxHeight: isExpandId == item.id ? '1000px' : '0px',
            padding: isExpandId == item.id ? '0 11px 13px' : '0px 0px',
            overflowY: isExpandId == item.id ? 'auto' : 'hidden'
          }"
        >
          <el-tooltip v-for="(element, idx) in item.knowledges" :key="element.id" effect="light" :content="element.knowledge_name" placement="top">
            <el-tag
              :closable="
                $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5112_${yy_ms}_4`]))
              "
              @close="handleClose(element.id, index, idx)"
              class="tag"
              type="info"
            >
              {{ element.knowledge_name.length >= 20 ? element.knowledge_name.substring(0, 20) + '...' : element.knowledge_name }}
            </el-tag>
          </el-tooltip>
				</div>
			</div>
		</div>

		<el-dialog
			title="新建分类"
			:visible.sync="dialogVisible"
			width="30%"
			:before-close="beforeClose"
			class="dialog"
			:close-on-click-modal="false"
		>
      <InputTopTip v-model="classValue" placeholder="分类名称" :marginTop="14" class="dialog-input">
        <el-input v-model="classValue" placeholder=""></el-input>
      </InputTopTip>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false" :disabled="loading">取 消</el-button>
				<el-button size="small" type="primary" @click="confirmClick" :loading="loading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			editVisible: false,
			tags: [],
			inputValue: [],
			rename: [],
			classValue: '',
			loading: false,
      sbid: '',
      isExpandId: null
		}
	},
	watch: {
		editVisible: {
			handler(val) {
				console.log(val)
				if (!val) {
					this.rename.forEach(element => {
						element.visible = false
					})
				}
			}
		}
	},
	async mounted() {
    const { sbid } =this.$route.params
    this.sbid = sbid
		await this.getKnowPointList()
	},
  computed: {
		yy_ms() {
			return this.sbid == 1 ? 'yy' : this.sbid == 2 ? 'ms' : ''
		}
	},
	methods: {
		async editKnowPointClassName(index, id, name) {
			try {
				this.tags[index].knowledge_name = name
				await this.updateKnowPointClass(id, name)
				this.editVisible = false
			} catch (err) {
				this.getKnowPointList()
			}
		},
		editKnowPointClass(index, id) {
			let num = this.tags[index]?.knowledges?.length
			let name = this.tags[index]?.knowledge_name
			let text
			if (num > 0) {
				let nameList = this.tags[index]?.knowledges?.map(item => item.knowledge_name)
				text = `作品分类下有 ${num} 个小知识点删除温馨提示：请问是否删除【${name}】 分类，删除后分类中  ${nameList.join(
					'、'
				)}  等${num}个小知识点也会同步删除哦?`
			} else {
				text = `请问是否删除【${name}】分类?`
			}
			this.$confirm(text, '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				this.tags.splice(index, 1)
				this.rename.splice(index, 1)
				try {
					this.editVisible = false
					await this.deleteKnowPointClass(id)
				} catch (err) {
					this.getKnowPointList()
				}
			})
		},
		async getKnowPointList() {
			const data = await this.$api.question_set.getKnowPointList({
        fb_subject_id: this.sbid
      })
      this.tags = data
			this.rename = data.map(item => {
				return {
					visible: false,
					value: item.knowledge_name,
				}
			})
		},
		async beforeClose(done) {
			if (this.loading) return
			done()
		},
		async confirmClick() {
      try {
        this.loading = true
        await this.$api.question_set.createKnowPointClass({
          pid: 0,
          knowledge_name: this.classValue,
          subject_id: this.sbid
        })
        this.getKnowPointList()
        this.loading = false
        this.dialogVisible = false
      } catch(err) {
        this.loading = false
      }
		},
		async handleClose(id, index, idx) {
			this.tags[index].knowledges.splice(idx, 1)
			try {
				await this.deleteKnowPointClass(id)
			} catch (err) {
				this.getKnowPointList()
			}
		},
		async handleInputConfirm(id, knowledge_name, index) {
			// this.tags[index].knowledges.push({
			// 	id: new Date().getTime(),
			// 	pid: 0,
			// 	type: 0,
			// 	knowledge_name: knowledge_name,
			// 	created_at: new Date().getTime(),
			// 	updated_at: new Date().getTime(),
			// 	knowledges: []
			// })
      if (!knowledge_name) return
      if (this.loading) return
			try {
        this.loading = true
				await this.$api.question_set.createKnowPointClass({
					pid: id,
					knowledge_name: knowledge_name,
          subject_id: this.sbid
				})
				this.inputValue[id] = ''
				this.getPowerPointList()
        this.loading = false
			} catch (err) {
				this.getKnowPointList()
        this.loading = false
			}
      this.isExpandId = id
		},
		async updateKnowPointClass(id, name) {
			await this.$api.question_set.updateKnowPointClass(id, {
				knowledge_name: name,
        subject_id: this.sbid
			})
		},
		async deleteKnowPointClass(id) {
			await this.$api.question_set.deleteKnowPointClass(id, {})
		}
	}
}
</script>
<style lang="scss" scoped>
.know {
	background: #ffffff;
	border-radius: 12px;
	margin: 5px;
	padding: 16px;
	border: 2px solid #f5f5fb;
	// padding: 21px;
	// height: calc(100vh - 102px);
}
.flex {
	display: flex;
	justify-content: space-between;
}
.new-create {
	height: 33px;
	line-height: 33px;
	background: #f5f5fb;
	border-radius: 4px 4px 4px 4px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}
.dialog {
	/deep/ .el-dialog__title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		border-top: 2px solid #f8f8f8;
		border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
}

.dialog-input {
	margin: 38px 0;
}
.title {
	font-size: 20px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #3e3e3e;
	margin-bottom: 29px;
}
.subtitle {
	font-size: 16px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #737373;
}
.point {
	border: 1px #ffffff solid;
	background: #f9fbff;
	margin-bottom: 24px;
}
.point-header {
	border-bottom: 1px #ffffff solid;
	padding: 6px 12px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	border: 2px solid #f5f5fb;
}
.point-context {
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	background: #f9fbff;
	// min-height: 199px;
	border-radius: 6px 6px 6px 6px;
}
.point-header-input {
	width: 213px;
	background: #f5f7fa;
	border-radius: 4px 4px 4px 4px;
}
.tag {
	height: 30px;
	background: #e4e8f8;
	border-radius: 4px 4px 4px 4px;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #494949;
	margin-right: 30px;
	margin-top: 8px;
}
.text-ellipsis {
  width: 15ch; /* 限制文本宽度为15个字符 */
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏溢出的文本 */
  text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
}
</style>
